import {
  LANG_DE,
  LANG_EN,
  LANG_ES,
  LANG_FR,
  LANG_IT,
} from '../../core/lang/constants';


export const LANG_ANY = 'any';

export const AFFILIATE_TOOL_TYPE__ANIMATED_BANNER = 'ANIMATED_BANNER';
export const AFFILIATE_TOOL_TYPE__CUSTOM_THUMBNAIL = 'CUSTOM_THUMBNAIL';
export const AFFILIATE_TOOL_TYPE__CUSTOM_THUMBNAIL_PROMO_CHAT = 'CUSTOM_THUMBNAIL_PROMO_CHAT';
export const AFFILIATE_TOOL_TYPE__HTML5 = 'HTML5';
export const AFFILIATE_TOOL_TYPE__HTML5_GEO = 'HTML5_GEO';
export const AFFILIATE_TOOL_TYPE__GIF = 'GIF';
export const AFFILIATE_TOOL_TYPE__JPEG = 'JPEG';
export const AFFILIATE_TOOL_TYPE__LIVE_CHAT_FEED = 'LIVE_CHAT_FEED';
export const AFFILIATE_TOOL_TYPE__LIVE_VIDEO_FEED = 'LIVE_VIDEO_FEED';
export const AFFILIATE_TOOL_TYPE__POPUNDER_TOOL = 'POPUNDER_TOOL';
export const AFFILIATE_TOOL_TYPE__POPUP_TOOL = 'POPUP_TOOL';
export const AFFILIATE_TOOL_TYPE__PRESENTATION = 'PRESENTATION';
export const AFFILIATE_TOOL_TYPE__RSS_FEED = 'RSS_FEED';
export const AFFILIATE_TOOL_TYPE__SIMPLE_LINK = 'SIMPLE_LINK';
export const AFFILIATE_TOOL_TYPE__SLIDE_BOX = 'SLIDE_BOX';
export const AFFILIATE_TOOL_TYPE__TEXT_LINK = 'TEXT_LINK';
export const AFFILIATE_TOOL_TYPE__WINDOW_LIVE_CHAT_FEED = 'WINDOW_LIVE_CHAT_FEED';

export const affiliateToolTypeLangKeys = {
  [AFFILIATE_TOOL_TYPE__ANIMATED_BANNER]: 'affiliate-tool.type.animated-banner',
  [AFFILIATE_TOOL_TYPE__CUSTOM_THUMBNAIL]: 'affiliate-tool.type.custom-thumbnail',
  [AFFILIATE_TOOL_TYPE__CUSTOM_THUMBNAIL_PROMO_CHAT]: 'affiliate-tool.type.custom-thumbnail-promo-chat',
  [AFFILIATE_TOOL_TYPE__HTML5]: 'affiliate-tool.type.html5',
  [AFFILIATE_TOOL_TYPE__HTML5_GEO]: 'affiliate-tool.type.html5-geo',
  [AFFILIATE_TOOL_TYPE__GIF]: 'affiliate-tool.type.gif',
  [AFFILIATE_TOOL_TYPE__JPEG]: 'affiliate-tool.type.jpeg',
  [AFFILIATE_TOOL_TYPE__LIVE_CHAT_FEED]: 'affiliate-tool.type.live-chat-feed',
  [AFFILIATE_TOOL_TYPE__LIVE_VIDEO_FEED]: 'affiliate-tool.type.live-video-feed',
  [AFFILIATE_TOOL_TYPE__POPUNDER_TOOL]: 'affiliate-tool.type.popunder-tool',
  [AFFILIATE_TOOL_TYPE__POPUP_TOOL]: 'affiliate-tool.type.popup-tool',
  [AFFILIATE_TOOL_TYPE__PRESENTATION]: 'affiliate-tool.type.presentation',
  [AFFILIATE_TOOL_TYPE__RSS_FEED]: 'affiliate-tool.type.rss-feed',
  [AFFILIATE_TOOL_TYPE__SIMPLE_LINK]: 'affiliate-tool.type.simple-link',
  [AFFILIATE_TOOL_TYPE__SLIDE_BOX]: 'affiliate-tool.type.slide-box',
  [AFFILIATE_TOOL_TYPE__TEXT_LINK]: 'affiliate-tool.type.text-link',
  [AFFILIATE_TOOL_TYPE__WINDOW_LIVE_CHAT_FEED]: 'affiliate-tool.type.window-live-chat-feed',
};

export const affiliateToolTypeHelpLangKeys = {
  [AFFILIATE_TOOL_TYPE__ANIMATED_BANNER]: 'affiliate-tool.type-description.animated-banner',
  [AFFILIATE_TOOL_TYPE__CUSTOM_THUMBNAIL]: 'affiliate-tool.type-description.custom-thumbnail',
  [AFFILIATE_TOOL_TYPE__CUSTOM_THUMBNAIL_PROMO_CHAT]: 'affiliate-tool.type-description.custom-thumbnail-promo-chat',
  [AFFILIATE_TOOL_TYPE__GIF]: 'affiliate-tool.type-description.gif',
  [AFFILIATE_TOOL_TYPE__HTML5]: 'affiliate-tool.type-description.html5',
  [AFFILIATE_TOOL_TYPE__HTML5_GEO]: 'affiliate-tool.type-description.html5-geo',
  [AFFILIATE_TOOL_TYPE__JPEG]: 'affiliate-tool.type-description.jpeg',
  [AFFILIATE_TOOL_TYPE__LIVE_CHAT_FEED]: 'affiliate-tool.type-description.live-chat-feed',
  [AFFILIATE_TOOL_TYPE__LIVE_VIDEO_FEED]: 'affiliate-tool.type-description.live-video-feed',
  [AFFILIATE_TOOL_TYPE__POPUNDER_TOOL]: 'affiliate-tool.type-description.popunder-tool',
  [AFFILIATE_TOOL_TYPE__POPUP_TOOL]: 'affiliate-tool.type-description.popup-tool',
  [AFFILIATE_TOOL_TYPE__PRESENTATION]: 'affiliate-tool.type-description.presentation',
  [AFFILIATE_TOOL_TYPE__RSS_FEED]: 'affiliate-tool.type-description.rss-feed',
  [AFFILIATE_TOOL_TYPE__SIMPLE_LINK]: 'affiliate-tool.type-description.simple-link',
  [AFFILIATE_TOOL_TYPE__SLIDE_BOX]: 'affiliate-tool.type-description.slide-box',
  [AFFILIATE_TOOL_TYPE__TEXT_LINK]: 'affiliate-tool.type-description.text-link',
  [AFFILIATE_TOOL_TYPE__WINDOW_LIVE_CHAT_FEED]: 'affiliate-tool.type-description.window-live-chat-feed',
};

export const customThumbnailLangs = [
  LANG_IT,
  LANG_EN,
  LANG_FR,
  LANG_DE,
  LANG_ES,
];

export const PROFILE_INFO_POSITION__TOP = 't';
export const PROFILE_INFO_POSITION__RIGHT = 'r';
export const PROFILE_INFO_POSITION__BOTTOM = 'b';
const PROFILE_INFO_POSITION__LEFT = 'l';

export const profilePositions = [
  PROFILE_INFO_POSITION__TOP,
  PROFILE_INFO_POSITION__RIGHT,
  PROFILE_INFO_POSITION__BOTTOM,
  PROFILE_INFO_POSITION__LEFT,
];

export const profilePositionLangKeys = {
  [PROFILE_INFO_POSITION__TOP]: 'msg.top',
  [PROFILE_INFO_POSITION__RIGHT]: 'msg.right',
  [PROFILE_INFO_POSITION__BOTTOM]: 'msg.bottom',
  [PROFILE_INFO_POSITION__LEFT]: 'msg.left',
};

export const customThumbnailSizes = [
  {
    width: 30,
    height: 30,
  },
  {
    width: 40,
    height: 40,
  },
  {
    width: 50,
    height: 50,
  },
  {
    width: 60,
    height: 60,
  },
  {
    width: 70,
    height: 70,
  },
  {
    width: 80,
    height: 80,
  },
  {
    width: 133,
    height: 133,
  },
];

export const POPUP_TYPE__DEFAULT = 'default';
export const POPUP_TYPE__FACEBOOK = 'facebook';
export const POPUP_TYPE__GRITTER = 'gritter';
export const POPUP_TYPE__LIVECHAT = 'livechat';
export const POPUP_TYPE__SKYPE = 'skype';
export const POPUP_TYPE__NUDEINCAM = 'nudeincam';

export const popupTypes = [
  POPUP_TYPE__SKYPE,
  POPUP_TYPE__FACEBOOK,
  POPUP_TYPE__DEFAULT,
  POPUP_TYPE__GRITTER,
  POPUP_TYPE__LIVECHAT,
  POPUP_TYPE__NUDEINCAM,
];

export const popupTypeLangKeys = {
  [POPUP_TYPE__SKYPE]: 'msg.popup.type.skype',
  [POPUP_TYPE__FACEBOOK]: 'msg.popup.type.facebook',
  [POPUP_TYPE__DEFAULT]: 'msg.popup.type.default',
  [POPUP_TYPE__GRITTER]: 'msg.popup.type.gritter',
  [POPUP_TYPE__LIVECHAT]: 'msg.popup.type.livechat',
  [POPUP_TYPE__NUDEINCAM]: 'msg.popup.type.nudeincam',
};

const RSS_FEED_TYPE__EROTIC_STORIES = 'eroticstories';
const RSS_FEED_TYPE__LATEST_ARRIVAL = 'latestarrival';
const RSS_FEED_TYPE__LIVE_SHOW = 'liveshow';
const RSS_FEED_TYPE__ONLINE_GIRLS = 'onlinegirls';
const RSS_FEED_TYPE__VIDEO = 'video';

export const rssFeedTypes = [
  RSS_FEED_TYPE__EROTIC_STORIES,
  RSS_FEED_TYPE__LATEST_ARRIVAL,
  RSS_FEED_TYPE__LIVE_SHOW,
  RSS_FEED_TYPE__ONLINE_GIRLS,
  RSS_FEED_TYPE__VIDEO,
];

export const rssFeedTypeLangKeys = {
  [RSS_FEED_TYPE__EROTIC_STORIES]: 'msg.rss-feed.type.erotic-stories',
  [RSS_FEED_TYPE__LATEST_ARRIVAL]: 'msg.rss-feed.type.latest-arrival',
  [RSS_FEED_TYPE__LIVE_SHOW]: 'msg.rss-feed.type.live-show',
  [RSS_FEED_TYPE__ONLINE_GIRLS]: 'msg.rss-feed.type.online-girls',
  [RSS_FEED_TYPE__VIDEO]: 'msg.rss-feed.type.video',
};

export const VIDEO_CHAT_TYPE__PERSONAL_ROOM_JS = 'personalroomjs';
export const VIDEO_CHAT_TYPE__PERSONAL_ROOM_FLASH = 'personalroomflash';
export const VIDEO_CHAT_TYPE__PUBLIC_ROOM = 'publicroom';

export const videoChatTypes = [
  VIDEO_CHAT_TYPE__PERSONAL_ROOM_JS,
  VIDEO_CHAT_TYPE__PERSONAL_ROOM_FLASH,
  VIDEO_CHAT_TYPE__PUBLIC_ROOM,
];

export const videoChatTypeLangKeys = {
  [VIDEO_CHAT_TYPE__PERSONAL_ROOM_JS]: 'msg.video-chat.type.personal-room-js',
  [VIDEO_CHAT_TYPE__PERSONAL_ROOM_FLASH]: 'msg.video-chat.type.personal-room-flash',
  [VIDEO_CHAT_TYPE__PUBLIC_ROOM]: 'msg.video-chat.type.public-room',
};

export const VIDEO_CHAT_WINDOW_TYPE__CODE = 'code';
export const VIDEO_CHAT_WINDOW_TYPE__POPUP = 'popup';
export const VIDEO_CHAT_WINDOW_TYPE__POPUNDER = 'popunder';

export const videoChatWindowTypes = [
  VIDEO_CHAT_WINDOW_TYPE__CODE,
  VIDEO_CHAT_WINDOW_TYPE__POPUP,
  VIDEO_CHAT_WINDOW_TYPE__POPUNDER,
];

export const videoChatWindowTypeLangKeys = {
  [VIDEO_CHAT_WINDOW_TYPE__CODE]: 'msg.video-chat.window.type.code',
  [VIDEO_CHAT_WINDOW_TYPE__POPUP]: 'msg.video-chat.window.type.popup',
  [VIDEO_CHAT_WINDOW_TYPE__POPUNDER]: 'msg.video-chat.window.type.popunder',
};

export const VIDEO_CHAT_WINDOW_ORIENTATION__LANDSCAPE = 'landscape';
export const VIDEO_CHAT_WINDOW_ORIENTATION__PORTRAIT = 'portrait';

export const videoChatWindowOrientations = [
  VIDEO_CHAT_WINDOW_ORIENTATION__LANDSCAPE,
  VIDEO_CHAT_WINDOW_ORIENTATION__PORTRAIT,
];

export const videoChatWindowOrientationLangKeys = {
  [VIDEO_CHAT_WINDOW_ORIENTATION__LANDSCAPE]: 'msg.video-chat.window.orientation.landscape',
  [VIDEO_CHAT_WINDOW_ORIENTATION__PORTRAIT]: 'msg.video-chat.window.orientation.portrait',
};

export const WINDOW_LIVE_CHAT_FEED_MIN_SIZE__JS = {
  [VIDEO_CHAT_WINDOW_ORIENTATION__LANDSCAPE]: {
    width: 520,
    height: 273,
  },
  [VIDEO_CHAT_WINDOW_ORIENTATION__PORTRAIT]: {
    width: 200,
    height: 519,
  },
};

export const WINDOW_LIVE_CHAT_FEED_MAX_SIZE__JS = {
  [VIDEO_CHAT_WINDOW_ORIENTATION__LANDSCAPE]: {
    width: 1000,
    height: 513,
  },
  [VIDEO_CHAT_WINDOW_ORIENTATION__PORTRAIT]: {
    width: 519,
    height: 1000,
  },
};

export const WINDOW_LIVE_CHAT_FEED_DEFAULT_SIZE__JS = {
  width: 700,
  height: 330,
};

export const WINDOW_LIVE_CHAT_FEED_MIN_SIZE__FLASH = {
  width: 200,
  height: 150,
};

export const WINDOW_LIVE_CHAT_FEED_MAX_SIZE__FLASH = {
  width: 640,
  height: 480,
};

export const WINDOW_LIVE_CHAT_FEED_DEFAULT_SIZE__FLASH = {
  width: 640,
  height: 330,
};

export const WINDOW_LIVE_CHAT_FEED_MIN_SIZE__PUBLIC = {
  width: 530,
  height: 500,
};

export const WINDOW_LIVE_CHAT_FEED_MAX_SIZE__PUBLIC = {
  width: 725,
  height: 581,
};

export const WINDOW_LIVE_CHAT_FEED_DEFAULT_SIZE__PUBLIC = {
  width: 640,
  height: 500,
};

export const WINDOW_OPEN_MODE__OPEN_ONCE = 'openOnce';
const WINDOW_OPEN_MODE__ALWAYS_OPEN = 'alwaysOpen';

export const windowOpenModes = [
  WINDOW_OPEN_MODE__OPEN_ONCE,
  WINDOW_OPEN_MODE__ALWAYS_OPEN,
];

export const windowOpenModeLangKeys = {
  [WINDOW_OPEN_MODE__OPEN_ONCE]: 'msg.open-once',
  [WINDOW_OPEN_MODE__ALWAYS_OPEN]: 'msg.always-open',
};

export const ANIMATED_BANNER_TYPE__HORIZONTAL = 'horizontal';

export const BANNER_SUBTYPE__FIXED = 'FIXED';
export const BANNER_SUBTYPE__FLEX_WIDTH = 'FLEX_WIDTH';

export const bannerSubtypes = [
  BANNER_SUBTYPE__FIXED,
  BANNER_SUBTYPE__FLEX_WIDTH,
];

export const bannerSubtypeLangKeys = {
  [BANNER_SUBTYPE__FIXED]: 'msg.banner.subtype.fixed',
  [BANNER_SUBTYPE__FLEX_WIDTH]: 'msg.banner.subtype.flex-width',
};
